/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard React Base Styles
import colors from "assets/theme/base/colors";

const { info, dark, light } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
  },
  body: {
    // Saturated parchment surface — sits a clear step below white so
    // cards and tables visibly lift off it. Same warm family as the
    // palette so it feels coordinated with the pastel-yellow hero.
    background: "#efe6cc",
    minHeight: "100vh",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  "*:focus": {
    outline: "none !important",
  },
  "*:focus-visible": {
    outline: "2px solid #000000 !important",
    outlineOffset: "2px",
  },
  "button:focus, input:focus, select:focus, textarea:focus": {
    outline: "none !important",
    borderColor: "#000000 !important",
  },
};

export default globals;
